import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { getLenis } from "@/hooks/useLenisScroll";

/*
  Simpler, reliable page transition:
  - key on pathname forces React to remount page content
  - no AnimatePresence "wait" mode (which was blocking new page mounting)
  - resets scroll via Lenis when available, native fallback otherwise
*/
export default function PageTransition({ children }) {
  const location = useLocation();

  useEffect(() => {
    const lenis = getLenis();
    if (lenis) {
      lenis.scrollTo(0, { immediate: true, force: true });
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [location.pathname]);

  return (
    <motion.div
      key={location.pathname}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1] }}
      data-testid="page-transition"
    >
      {children}
    </motion.div>
  );
}
